import * as React from "react";
import PropTypes from "prop-types";
const SvgSportsWindsurfNormalMedium = React.forwardRef(
  ({ color = "currentColor", size = 32, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M19.228 0h2.79c.593 0 1.258.209 1.748.751 1.178 1.303 3.984 5.32 3.984 13.832 0 5.172-1.035 9-2.095 11.562A20.73 20.73 0 0124.781 28H32v2.5H7V28h14.87a10.76 10.76 0 00.422-.67L7.135 21.5H3V19h2.603L17.055 1.186A2.583 2.583 0 0119.228 0zm-5.13 21.5l9.294 3.574c.395-.971.792-2.16 1.116-3.574zM24.963 19c.18-1.325.288-2.797.288-4.417V14.5H16V12h9.152a27.993 27.993 0 00-.158-1.5H19V8h5.527a19.091 19.091 0 00-.433-1.5H21V4h2.006a8.91 8.91 0 00-1.03-1.5h-2.748a.083.083 0 00-.07.038L8.575 19z"
        fill=""
      />
    </svg>
  )
);
SvgSportsWindsurfNormalMedium.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgSportsWindsurfNormalMedium;
